import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-switcher',
  templateUrl: './switcher.component.html',
  styleUrls: ['./switcher.component.scss']
})
export class SwitcherComponent implements OnInit {

  @Input() public title:string = "";
  @Input() public switcher:boolean = true;
  @Input() public element:string = "switcher";
  @Input() public disabled: boolean = false;
  @Output() public callback:EventEmitter<boolean> = new EventEmitter;
  @Output() public setcallback:EventEmitter<boolean> = new EventEmitter;
  public auxSwicher:any;
  
  constructor() { }

  ngOnInit() {
  }

  change(){
    console.log('emitting... ', this.switcher);
    this.callback.emit(this.switcher)
    if(this.switcher == true){
      this.auxSwicher = 1;
    }
    else{
      this.auxSwicher = 0;
    }
    this.setcallback.emit(this.auxSwicher)
  }

}



// WEBPACK FOOTER //
// ./src/app/components/tools/switcher/switcher.component.ts